/* eslint-disable react/button-has-type */
import React, { useRef } from 'react';
import CanvasDraw from 'react-canvas-draw';
import { applyPainMapDotFix } from '@mummssoftware/utils/utils';
import painMapGif from './images/pain.gif';
export const PainMapReadOnly = ({
  subqchoice
}) => {
  const canvasRef = useRef(null); // CanvasDraw expects a string

  const savedData = subqchoice !== null && subqchoice !== void 0 && subqchoice.value && (subqchoice === null || subqchoice === void 0 ? void 0 : subqchoice.value) !== 'false' ? JSON.stringify(subqchoice.value) : undefined;
  return /*#__PURE__*/React.createElement("div", {
    id: "read-only-pain-map"
  }, /*#__PURE__*/React.createElement(CanvasDraw, {
    disabled: true,
    imgSrc: painMapGif,
    ref: canvasDraw => {
      canvasRef.current = canvasDraw;
      applyPainMapDotFix(canvasDraw);
    },
    canvasWidth: 600,
    canvasHeight: 245,
    saveData: savedData,
    style: {
      position: 'relative'
    }
  }));
};